<script setup lang="ts">
import { mapStatus } from '@/lib/utils';

defineProps({
    status: {
        type: String,
        required: true
    }
});

const statusColor = {
    'WinRx': 'text-blue-600',
    'Waiting': 'text-blue-600',
    'Visited': 'text-green-600',
    'Cancelled': 'text-rose-600',
    'Canceled': 'text-rose-600',
    'Deleted': 'text-rose-600',
    'No Show': 'text-rose-600',
    'Reserved': 'text-orange-500',
    'Billed': 'text-green-600',
    'Finished': 'text-green-600',
    'ReservationExpired': 'text-rose-600',
    'Changed': 'text-blue-600',
}
</script>

<template>
    <div 
        class="rounded-md py-1 px-2 border border-gray-300 font-semibold bg-white/70 backdrop-blur-sm z-30 text-sm absolute top-2.5 right-2.5 shadow-[-24px_0_12px_rgba(255,255,255,0.9)]" 
        :class="statusColor[status]"
    >
        {{ mapStatus(status, true) }}
    </div>
</template>
